import {Page, Text, View, Line, Document, StyleSheet, Svg} from '@react-pdf/renderer';

export const styles = StyleSheet.create({
    page: {
        flexDirection: 'row',
        backgroundColor: '#E4E4E4'
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1
    },
    row: {flexDirection: 'row', justifyContent: 'flex-start'},
    rowCenter: {flexDirection: "row", justifyContent: 'center'},
    col: {padding: 10},
    title: {
        fontSize: 24,
        textAlign: 'center',

    },

    smallTile: {
        marginTop: 20,
        fontSize: 18,
        textAlign: 'center',
    },
    smallestTile: {
        marginTop: 10,
        fontSize: 15,
        textAlign: 'center',
    },
    field: {flexDirection: 'row'},
    fieldTitle: {fontSize: 12},
    fieldText: {fontSize: 12}
});

export function ModelAPdf(props) {
    const {modelATempObject} = props;
    return <Document>
        <Page size="A4" style={styles.page}>
            <View style={styles.section}>
                <Text style={styles.title}>Model A Inschrijvingsformulier 'leden'</Text>
                <Text style={styles.smallTile}>A Algemeen</Text>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Sector-nr: </Text>
                            <Text style={styles.fieldText}>{modelATempObject.sectorNummer}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Sector: </Text>
                            <Text style={styles.fieldText}>{modelATempObject.sector}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Stam nr-club: </Text>
                            <Text style={styles.fieldText}>{modelATempObject.stamNrClub}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Club: </Text>
                            <Text style={styles.fieldText}>{modelATempObject.club}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Geboortedatum: </Text>
                            <Text style={styles.fieldText}>{modelATempObject.geboorteDatum}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Categorie: </Text>
                            <Text style={styles.fieldText}>{modelATempObject.categorie}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Geslacht: </Text>
                            <Text style={styles.fieldText}>{modelATempObject.sex}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Lidnr: </Text>
                            <Text style={styles.fieldText}>{modelATempObject.lidnummer}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Nationaliteit: </Text>
                            <Text style={styles.fieldText}>{modelATempObject.nationaliteit}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Naam: </Text>
                            <Text style={styles.fieldText}>{modelATempObject.naam}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Voornaam: </Text>
                            <Text style={styles.fieldText}>{modelATempObject.voornaam}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Rijksregnr: </Text>
                            <Text style={styles.fieldText}>{modelATempObject.rijksRegisterNummer}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.rowCenter}>
                    <Svg height="5" width="495">
                        <Line x1="0" y1="5" x2="495" y2="5" strokeWidth={1} stroke="rgb(0,0,0)"/>
                    </Svg>
                </View>
                <Text style={styles.smallTile}>B Woonplaats</Text>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Straat: </Text>
                            <Text style={styles.fieldText}>{modelATempObject.straat}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Huisnr: </Text>
                            <Text style={styles.fieldText}>{modelATempObject.nr}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Bus: </Text>
                            <Text style={styles.fieldText}>{modelATempObject.bus}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Land: </Text>
                            <Text style={styles.fieldText}>{modelATempObject.land}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Postcode: </Text>
                            <Text style={styles.fieldText}>{modelATempObject.postcode}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Gemeente: </Text>
                            <Text style={styles.fieldText}>{modelATempObject.gemeente}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Tel/Gsm: </Text>
                            <Text style={styles.fieldText}>+{modelATempObject.telefoon}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Email: </Text>
                            <Text style={styles.fieldText}>{modelATempObject.email}</Text>
                        </View>
                    </View>
                </View>
               <View style={styles.rowCenter}>
                   <Svg height="5" width="495">
                       <Line x1="0" y1="5" x2="495" y2="5" strokeWidth={1} stroke="rgb(0,0,0)"/>
                   </Svg>
               </View>
                <Text style={styles.smallTile}>B Woonplaats</Text>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Reden van indiening: </Text>
                            <Text style={styles.fieldText}>{modelATempObject.optie}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Opmerking: </Text>
                            <Text style={styles.fieldText}>{modelATempObject.opmerking}</Text>
                        </View>
                    </View>
                </View>
            </View>


        </Page>
    </Document>
}